import React from 'react';
import { ArrowRightIcon, ArrowLeftIcon, SparklesIcon, HomeIcon, FileTextIcon, CreditCardIcon, PawPrintIcon, CalendarIcon, HashIcon, SyringeIcon, UserIcon, CameraIcon, MoreHorizontalIcon, SignalIcon, WifiIcon, BatteryFullIcon } from 'lucide-react';
import { GreenCheck } from '../permis/PermisCards';
import { ANIMALS_IMAGES, animalsCopy, atnaChecks, petProfile, type Bi } from '../../data/animalsHero';
type P = {
  isFR: boolean;
};
const pk = (isFR: boolean) => (v: Bi) => isFR ? v.fr : v.en;
const CARD = 'border border-[#ECECF4] bg-white shadow-[0_24px_50px_-30px_rgba(40,36,120,0.5)]';
export function CitizenQuestion({
  isFR
}: P) {
  return <div className={`${CARD} rounded-[24px] p-3 pr-4 flex items-center gap-4`} data-id="element-66" data-mp="23aj50k3ugxub">
      <img src={ANIMALS_IMAGES.avatar} alt="" className="w-16 h-16 rounded-full object-cover shrink-0" data-id="element-67" data-mp="23cm4duqw03bp" />
      <p className="flex-1 font-sans text-[15px] xl:text-[16px] font-medium text-[#121A3A] leading-snug" data-id="element-68" data-mp="2h7xzi38yfvt5">{pk(isFR)(animalsCopy.question)}</p>
      <span className="w-11 h-11 rounded-full bg-[#F1F0FD] flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-69" data-mp="3s0am5l2u7piy">
        <ArrowRightIcon className="w-5 h-5 text-[#4F46E5]" strokeWidth={2.2} data-id="element-70" data-mp="3w1mcxtxg6gsq" />
      </span>
    </div>;
}
const CHECK_ICONS = {
  identity: HomeIcon,
  rules: FileTextIcon,
  payment: CreditCardIcon,
  medal: PawPrintIcon
} as const;
export function AtnaCard({
  isFR
}: P) {
  const pick = pk(isFR);
  return <div className={`${CARD} rounded-[22px] p-4 xl:p-5`} data-id="element-71" data-mp="esh7njbzxv7y">
      <div className="flex items-start gap-3.5" data-id="element-72" data-mp="iu2furdl5lbt">
        <span className="w-12 h-12 rounded-full bg-[#F1F0FD] flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-73" data-mp="isrfz2n9gxpz">
          <SparklesIcon className="w-6 h-6 text-[#4F46E5] fill-[#4F46E5]" strokeWidth={1.5} data-id="element-74" data-mp="skdxfgq6zt16" />
        </span>
        <div className="min-w-0" data-id="element-75" data-mp="xjqjhz98ow2p">
          <p className="font-sans text-[18px] font-semibold text-[#121A3A]" data-id="element-76" data-mp="xkjgw9mb6986">ATNA</p>
          <p className="font-sans text-[14px] text-[#5B6478] leading-snug mt-0.5" data-id="element-77" data-mp="12hs26j2r6tdn">{pick(animalsCopy.answer)}</p>
        </div>
      </div>
      <ul className="mt-4 rounded-2xl bg-[#FAFAFD] border border-[#F0F0F6] divide-y divide-[#EFEFF5]" data-id="element-78" data-mp="cuxsrs1j8wu5">
        {atnaChecks.map(c => {
        const Icon = CHECK_ICONS[c.key];
        return <li key={c.key} className="flex items-center gap-3 px-3.5 py-3" data-id="element-79" data-mp="mljzewr9ud0p">
              <Icon className="w-5 h-5 text-[#4F46E5] shrink-0" strokeWidth={1.7} aria-hidden="true" data-id="element-80" data-mp="hsqua7rw52o3" />
              <span className="flex-1 font-sans text-[14px] text-[#121A3A]" data-id="element-81" data-mp="vjm5hqpv3vuu">{pick(c.label)}</span>
              <GreenCheck size={22} data-id="element-82" data-mp="ql14hp2sd85c" />
            </li>;
      })}
      </ul>
    </div>;
}
const ROW_ICONS = {
  licence: HomeIcon,
  expiry: CalendarIcon,
  number: HashIcon,
  vaccine: SyringeIcon,
  contact: UserIcon
} as const;
export function PetPhone({
  isFR
}: P) {
  const pick = pk(isFR);
  return <div className="w-[270px] rounded-[42px] bg-[#1B1D26] p-[7px] shadow-[0_40px_70px_-36px_rgba(20,20,60,0.7)]" data-id="element-83" data-mp="37azxmcstl40d">
      <div className="rounded-[36px] bg-white overflow-hidden" data-id="element-84" data-mp="32d7tmkewhrft">
        <div className="relative flex items-center justify-between px-6 pt-3 pb-1 font-sans text-[11px] font-semibold text-[#121A3A]" aria-hidden="true" data-id="element-85" data-mp="1huds59zufazk">
          <span data-id="element-86" data-mp="1mu8mxomqokpw">9:41</span>
          <span className="absolute left-1/2 -translate-x-1/2 top-2 w-20 h-5 rounded-full bg-[#1B1D26]" data-id="element-87" data-mp="1841bvtz2a3z8" />
          <span className="flex items-center gap-1" data-id="element-88" data-mp="1d1ugwjomorxx">
            <SignalIcon className="w-3 h-3" data-id="element-89" data-mp="1d0jfgqinnw9z" />
            <WifiIcon className="w-3 h-3" data-id="element-90" data-mp="z2la2ambba6m" />
            <BatteryFullIcon className="w-3.5 h-3.5" data-id="element-91" data-mp="z4xr8lk8xgim" />
          </span>
        </div>
        <div className="flex items-center justify-between px-4 pt-3" data-id="element-92" data-mp="135zqv3i2rul4">
          <ArrowLeftIcon className="w-4 h-4 text-[#4F46E5]" strokeWidth={2.2} aria-hidden="true" data-id="element-93" data-mp="p5gp2e47dkre" />
          <p className="font-sans text-[14px] font-semibold text-[#121A3A]" data-id="element-94" data-mp="u2yp1f08spn9">{pick(petProfile.title)}</p>
          <MoreHorizontalIcon className="w-4 h-4 text-[#8A90A2]" aria-hidden="true" data-id="element-95" data-mp="2jjpxoi0kwwyg" />
        </div>
        <div className="flex flex-col items-center pt-4" data-id="element-96" data-mp="2ogq44u1cc1q3">
          <span className="relative" data-id="element-97" data-mp="ofjj38s63rkf">
            <img src={ANIMALS_IMAGES.milo} alt="Milo" className="w-[84px] h-[84px] rounded-full object-cover" data-id="element-98" data-mp="oegtd46kzv63" />
            <span className="absolute bottom-0 right-0 w-6 h-6 rounded-full bg-white border border-[#ECECF4] flex items-center justify-center" aria-hidden="true" data-id="element-99" data-mp="jhqdagus0zko">
              <CameraIcon className="w-3 h-3 text-[#4F46E5]" data-id="element-100" data-mp="aga3obbsd1hi" />
            </span>
          </span>
          <p className="mt-2 font-sans text-[16px] font-semibold text-[#121A3A]" data-id="element-101" data-mp="5ge20iqk9m54">{petProfile.name}</p>
          <p className="font-sans text-[11.5px] text-[#8A90A2]" data-id="element-102" data-mp="pfh15umnzvj">{pick(petProfile.breed)}</p>
        </div>
        <ul className="mt-3 mx-3 mb-4 rounded-2xl border border-[#F0F0F6] divide-y divide-[#F0F0F6]" data-id="element-103" data-mp="3rvqnximbjuus">
          {petProfile.rows.map(r => {
          const Icon = ROW_ICONS[r.key];
          return <li key={r.key} className="flex items-center gap-2.5 px-3 py-2.5" data-id="element-104" data-mp="3ivtw584mufvi">
                <span className="w-6 h-6 rounded-md bg-[#F1F0FD] flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-105" data-mp="3dvxomywq86b7">
                  <Icon className="w-3.5 h-3.5 text-[#4F46E5]" strokeWidth={1.8} data-id="element-106" data-mp="1tdn5h6b8eg9i" />
                </span>
                <span className="flex-1 font-sans text-[11.5px] text-[#121A3A]" data-id="element-107" data-mp="1yc85b4mkmxxf">{pick(r.label)}</span>
                {r.value ? <span className="font-sans text-[11px] text-[#3A4258]" data-id="element-108" data-mp="23aruddwgopu0">{pick(r.value)}</span> : <span className="rounded-full bg-[#22A04F] px-2 py-0.5 font-sans text-[10px] font-semibold text-white" data-id="element-109" data-mp="1anx9wgzn9qgj">{pick(petProfile.active)}</span>}
              </li>;
        })}
        </ul>
      </div>
    </div>;
}